import store from 'store'

import api from 'api'

import type { AppRefresh } from 'context/AppRefreshContext'

export function signInUsingSaml(appRefresh: AppRefresh, companyName: string) {
  // Refresh Webapp When Logging In
  // since we're setting the href explicitly below, that reloads the webapp
  // so if it's marked as needing to be refreshed, then we can clear that here
  appRefresh.markAsRefreshed()

  window.location.href = api.authentication.generateSamlUrl({
    companyName,
    nextPathname: store.get('loginRedirect') ?? '/'
  })
}
